import { render } from "./MultiChoiceGrid.vue?vue&type=template&id=308da17a&scoped=true"
import script from "./MultiChoiceGrid.vue?vue&type=script&lang=js"
export * from "./MultiChoiceGrid.vue?vue&type=script&lang=js"

import "./MultiChoiceGrid.vue?vue&type=style&index=0&id=308da17a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308da17a"]])

export default __exports__